import { IFormErrors } from '@interfaces/IFormsErrors';
import { IGroup } from '@interfaces/IGroup';
import { Action } from '@ngrx/store';

export enum EGroupsActions {
  //request
  RequestAllGroups = '[Groups] Request Groups',

  //reset
  ResetErrors = '[Groups] Reset Errors',

  //get
  GetGroups = '[Groups] Get Groups',
  GetGroupsSuccess = '[Groups] Get GroupsSuccess',
  GetGroup = '[Groups] Get Group',
  GetGroupSuccess = '[Groups] Get Group Success',
  GetGroupsFailure = '[Groups] Get Groups Failure',

  //clear
  ClearStateGroups = '[Groups] Clear State Groups',

  openModalToAdmin = 'Open modal or not',
}

export class openModalToAdmin implements Action {
  public readonly type = EGroupsActions.openModalToAdmin;
  constructor(public open: boolean) {}
}
//request
export class RequestAllGroups implements Action {
  public readonly type = EGroupsActions.RequestAllGroups;
}

//get
export class GetGroups implements Action {
  public readonly type = EGroupsActions.GetGroups;

  constructor(public courseId?: number) {}
}

export class GetGroupsSuccess implements Action {
  public readonly type = EGroupsActions.GetGroupsSuccess;

  constructor(public groups: IGroup[]) {}
}

export class GetGroupsFailure implements Action {
  public readonly type = EGroupsActions.GetGroupsFailure;

  constructor(public errors: IFormErrors) {}
}

export class GetGroup implements Action {
  public readonly type = EGroupsActions.GetGroup;

  constructor(public id: number) {}
}

export class GetGroupSuccess implements Action {
  public readonly type = EGroupsActions.GetGroupSuccess;

  constructor(public group: IGroup) {}
}

//reset
export class ResetErrors implements Action {
  public readonly type = EGroupsActions.ResetErrors;
}

export class ClearGroupsState implements Action {
  public readonly type = EGroupsActions.ClearStateGroups;
}

export type GroupsActions =
  | ResetErrors
  | GetGroups
  | GetGroupsSuccess
  | GetGroupsFailure
  | GetGroupSuccess
  | RequestAllGroups
  | GetGroup
  | ClearGroupsState;
